import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { StreamService } from '../services/stream.service';
import { takeUntil, filter, flatMap, first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    styles: [`
        label: {
            padding-right: 15px;
        }
    `],
    template: `
        <mat-card>
            <mat-card-content fxLayout="column" fxFlexOffset.gt-xs="15">
                <div fxLayout="row">
                    <mat-slide-toggle [checked]="!topic.settings.aggregationDisabled" (change)="toggleAggregation()">
                        Active
                    </mat-slide-toggle>
                </div>
                <div fxLayout="row" style="padding-top: 15px;">
                    <label style="padding-right: 20px; padding-top: 5px;">Last Status</label>
                    <span *ngIf="topic.status.inError" 
                          [matTooltip]="topic.status.lastFailure | amTimeAgo"
                          style="color: red;">
                        <mat-icon>clear</mat-icon>
                    </span>
                    <span *ngIf="!topic.status.inError"
                          [matTooltip]="topic.status.lastAttempted | amTimeAgo"
                          style="color: green;">
                        <mat-icon>done</mat-icon>
                    </span>
                </div>
                <div fxLayout="row" style="padding-top: 15px;">
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput name="lastSuccess" disabled="true" [ngModel]="topic.status.lastSuccess | amTimeAgo" placeholder="Last Success">
                    </mat-form-field>
                </div>
                <div fxLayout="row" style="padding-top: 15px;">
                    <mat-form-field *ngIf="topic.status.lastFailure" fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput name="lastError" disabled="true" [ngModel]="topic.status.lastFailure | amTimeAgo" placeholder="Last Error">
                    </mat-form-field>
                    <mat-form-field *ngIf="!topic.status.lastFailure" fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput name="lastError" disabled="true" placeholder="Last Error">
                    </mat-form-field>
                </div>
                <div fxLayout="row" style="padding-top: 15px;">
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <textarea matInput name="lastErrorMessage" disabled="true" [(ngModel)]="topic.status.lastErrorMessage" placeholder="Last Error Message"></textarea>
                    </mat-form-field>
                </div>
                <div fxLayout="row" style="padding-top: 15px;">
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput name="totalItems" disabled="true" [(ngModel)]="topic.itemsCount" placeholder="Total Items">
                    </mat-form-field>
                </div>
                <div fxLayout="row" style="padding-top: 15px;">
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput name="averageItems" disabled="true" [ngModel]="topic.status.averageItemsPerHour | number:'1.1-3'" placeholder="Average Items">
                        <span matSuffix>per hour</span>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>
    `
})
export class SourceAggregationComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    topic: any;
    
    constructor(private snackBar: MatSnackBar, route: ActivatedRoute, private streamService: StreamService) {
        route.parent.params 
        .pipe(
            takeUntil(this.cleanupTime),
            filter(params => !!params.topicId),
            flatMap(params => streamService.getStream(params.topicId))
        )
        .subscribe(topic => this.topic = topic);
    }

    toggleAggregation(): void {
        this.topic.settings.aggregationDisabled = !this.topic.settings.aggregationDisabled;
        this.streamService.updateStream(this.topic).pipe(first())
        .subscribe(() => this.snackBar.open(`Aggregation ${this.topic.settings.aggregationDisabled ? 'disabled' : 'enabled' }`, 'OK', { duration: 3000}));
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}